import { latestNewsGridSection } from '@stereoagency/sanity-schema';
import { $globalSanityClient } from '@/sanity';
import { newsQuery } from './newsQuery';
import UILatestNewsGridSection from './LatestNewsGridSection.client';

type Props = typeof latestNewsGridSection.schema.latestNewsGridSection;

export default async function LatestNewsGridSection({ action, title }: Props) {
  const data = await $globalSanityClient.fetch<(typeof newsQuery)[1]>(
    newsQuery[0]
  );

  return (
    <UILatestNewsGridSection title={title} action={action} articles={data} />
  );
}
